// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled[data-v-25f90316] {\n  cursor: not-allowed;\n  color: gray;\n}", ""]);
// Exports
module.exports = exports;
